import CheckBox from "../components/sharedComponents/checkbox/checkbox";
import TextInput from "../components/sharedComponents/inputs/textInput";
import { paths } from "../paths/paths";
import Lang from "../userPreferences/staticWords";

export function removeItem(arr) {
  let what,
    a = arguments,
    L = a.length,
    ax;
  while (L > 1 && arr.length) {
    what = a[--L];
    while ((ax = arr.indexOf(what)) !== -1) {
      arr.splice(ax, 1);
    }
  }
  return arr;
}

const MembersList = ({
  containerStyle,
  aboveTitleStyle,
  aboveTitle,
  cardStyle,
  cardTitle,
  list,
  onChange,
  listError,
  checked,
  values,
  id,
  idChar,
  onChangeSearch,
  targetId,
  target,
}) => {
  return (
    <div className={containerStyle}>
      <div className={aboveTitleStyle}>
        <p className="my-0">{aboveTitle}</p>
      </div>

      <div
        className={cardStyle}
        style={{
          height: "fit-content",
          maxHeight: 250,
        }}
      >
        {onChangeSearch ? (
          <div className="d-flex mb-3 mt-2">
            <TextInput
              containerStyle={"col-9"}
              type={"text"}
              hiddenPlaceholder={Lang.search}
              onChange={onChangeSearch}
            />
            {/* <p style={{ color: "#1A73E8" }}>{cardTitle}</p> */}
          </div>
        ) : null}
        {list?.length > 0 ? (
          <div className="d-flex flex-column scroll">
            {list.map((item, index) => {
              let memberPhoto;
              if (item?.memberPhoto != null)
                memberPhoto = `url("${paths.MemberPhoto}${item.memberId}/${item.memberPhoto}")`;
              else memberPhoto = `url("/assets/images/userPlaceholder.png")`;
              return (
                <MemberListItem
                  key={index}
                  id={item?.memberId}
                  photo={memberPhoto}
                  index={index}
                  name={item?.memberName ? item?.memberName : item?.name}
                  onChange={onChange}
                  values={values}
                  length={list.length - index}
                  checked={checked}
                  idChar={id}
                  targetId={item?.id}
                  target={target}
                />
              );
            })}
          </div>
        ) : (
          <div className="m-auto my-5">{Lang.noMembers}</div>
        )}
        <div style={{ fontSize: 14, color: "red" }}>
          {listError ? (
            <div className="text-center text-danger" style={{ fontSize: 14 }}>
              {Lang.require}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default MembersList;

export const MemberListItem = ({
  id,
  photo,
  name,
  index,
  checked,
  values,
  onChange,
  length,
  idChar,
  targetId,
  target,
}) => {
  return (
    <div className="d-flex flex-column" key={id}>
      <div className="d-flex">
        <div className="d-flex align-items-center justify-content-start col-10">
          {!target && (
            <div
              style={{
                backgroundImage: photo, //change image here
                width: 30,
                height: 30,
                borderRadius: "30%",
                backgroundPosition: "center",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                border: "1px solid white",
              }}
            ></div>
          )}
          <p className="my-0 mx-1" style={{ fontWeight: "bold" }}>
            {name}
          </p>
        </div>
        <div className="d-flex align-items-center justify-content-end col-2">
          <CheckBox
            id={
              target == true
                ? targetId
                : idChar == "A"
                  ? index + name
                  : name + index
            }
            // v={targetId == true ? }
            value={id}
            // checked={
            //   checked ? values.find((member) => member == targetId) : null
            // }
            checked={
              checked
                ? Array.isArray(values)
                  ? target === true
                    ? values.includes(targetId)
                    : values.includes(id)
                  : target === true
                    ? values === targetId
                    : values === id
                : false
            }
            onChange={onChange}
          />
        </div>
      </div>
      {length - 1 > 0 ? (
        <div className="d-flex justify-content-center px-2">
          <hr
            className="col-12 my-2"
            style={{ backgroundColor: "#707070" }}
          ></hr>
        </div>
      ) : null}
    </div>
  );
};
